import { render, staticRenderFns } from "./BiomarkerMechanismLinkSummary.vue?vue&type=template&id=4e7ca07c&scoped=true"
import script from "./BiomarkerMechanismLinkSummary.vue?vue&type=script&lang=js"
export * from "./BiomarkerMechanismLinkSummary.vue?vue&type=script&lang=js"
import style0 from "./BiomarkerMechanismLinkSummary.vue?vue&type=style&index=0&id=4e7ca07c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7ca07c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7ca07c')) {
      api.createRecord('4e7ca07c', component.options)
    } else {
      api.reload('4e7ca07c', component.options)
    }
    module.hot.accept("./BiomarkerMechanismLinkSummary.vue?vue&type=template&id=4e7ca07c&scoped=true", function () {
      api.rerender('4e7ca07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/biomarkerNetwork/BiomarkerMechanismLinkSummary.vue"
export default component.exports